import React from "react";
import * as THREE from "three";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass.js";
import { Canvas, extend, useFrame, useThree } from "@react-three/fiber";

extend({ EffectComposer, RenderPass, UnrealBloomPass });

const Effects = () => {
  const { gl, scene, camera, size } = useThree();
  const composer = React.useRef();
  const textureLoader = new THREE.TextureLoader();
  const backgroundTexture = textureLoader.load("/galaxy1.png");

  React.useEffect(() => {
    composer.current = new EffectComposer(gl);
    const renderPass = new RenderPass(scene, camera);
    composer.current.addPass(renderPass);

    const bloomPass = new UnrealBloomPass(
      new THREE.Vector2(window.innerWidth, window.innerHeight),
      2,
      0,
      0
    );
    composer.current.addPass(bloomPass);
    scene.background = backgroundTexture;

    return () => {
      // Clean up
      composer.current.setSize(size.width, size.height);
      composer.current.reset();
    };
  }, [gl, scene, camera, size, backgroundTexture]);

  useFrame(() => {
    if (composer.current) {
      composer.current.render();
    }
  }, 1);

  return null;
};

const Suns = ({ speed }) => {
  const colors = ["white", "cyan", "pink", "orange", "salmon"];
  const sunsRef = React.useRef([]);
  useFrame(() => {
    if (sunsRef.current.length > 0) {
      sunsRef.current.forEach((v) => {
        if (v.position.z > 0) {
          v.position.z = -600;
          v.position.x = Math.random() * 1000 - 500;
          v.position.y = Math.random() * 1000 - 500;
        } else {
          v.position.z += speed;
        }
      });
    }
  });
  return Array(1000)
    .fill(0)
    .map((_, i) => (
      <mesh
        key={i}
        ref={(mesh) => sunsRef.current.push(mesh)}
        position={[
          Math.random() * 1000 - 500,
          Math.random() * 1000 - 500,
          Math.random() * 500 - 600,
        ]}
      >
        <icosahedronGeometry args={[0.5, 15]} />
        <meshBasicMaterial color={colors[Math.floor(Math.random() * 5)]} />
      </mesh>
    ));
};

export const ThreeAnimation = () => {
  return (
    <div>
      <div
        style={{
          position: "fixed",
          zIndex: -100,
          top: 0,
          width: "100%",
          height: "100vh",
        }}
      >
        <Canvas>
          <Suns speed={0.5} />
          <Effects />
        </Canvas>
      </div>
    </div>
  );
};
